import React from "react";
import { Eye } from "lucide-react";

/** One track row; its campaign summary opens the full list in a window. */
const CtmRow = ({
  row,
  languageLabel,
  canManage,
  isDeleting,
  onEdit,
  onDelete,
  onViewCampaigns,
}) => {
  const accounts = row.campaign_accounts || [];

  return (
    <tr className="transition-colors hover:bg-gray-50/50">
      <td className="py-4 px-4 text-sm text-gray-600">{row.app_name || "—"}</td>
      <td className="py-4 px-4 text-sm text-gray-600">{languageLabel}</td>
      <td className="py-4 px-4 text-sm text-gray-600">{row.category || "—"}</td>
      <td className="py-4 px-4 text-sm text-gray-600">{row.track || "—"}</td>
      <td className="py-4 px-4 text-sm text-gray-600">
        {row.track_number ?? "—"}
      </td>
      <td className="py-4 px-4 text-sm text-gray-600">
        {accounts.length ? (
          <button
            type="button"
            onClick={onViewCampaigns}
            className="-mx-2 flex items-start gap-1.5 rounded-md px-2 py-1 text-left hover:bg-gray-100"
            title="View campaigns"
          >
            <Eye className="mt-0.5 h-4 w-4 shrink-0 text-gray-500" />
            <span className="space-y-0.5">
              {accounts.map((a) => (
                <span
                  key={a.meta_ad_account_id}
                  className="block whitespace-nowrap"
                >
                  {a.ad_account_name}
                  <span className="text-gray-400"> · {a.campaigns.length}</span>
                </span>
              ))}
            </span>
          </button>
        ) : (
          "—"
        )}
      </td>
      {canManage && (
        <td className="py-4 px-4 text-sm">
          <div className="flex gap-2">
            <button
              type="button"
              onClick={onEdit}
              className="font-medium text-primaryPurple hover:underline"
            >
              Edit
            </button>
            <button
              type="button"
              onClick={onDelete}
              disabled={isDeleting}
              className="font-medium text-rose-600 hover:underline disabled:opacity-50"
            >
              Delete
            </button>
          </div>
        </td>
      )}
    </tr>
  );
};

export default CtmRow;
